<template>
  <div class="block-split__header mx-4">
    <div class="u-md-3 mt-5 mb-1">
      <h1>{{ translateContact.title }}</h1>
      <h3 class="u-md-3">
        {{ translateContact.subTitle }}
      </h3>
    </div>
    <CollapseBox :titles="translateContact.labelFaq" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import translateContact from 'tradutors/contact'
  import IconeBds from 'assets/img/icone_BDS.png'
  import CollapseBox from 'components/CollapseBox'

  export default defineComponent({
    name: 'BoxTitle',
    components: {
      CollapseBox
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      translateContact: function () {
        if (this.locale === 'pt-br') {
          return translateContact.portugues
        } else {
          return translateContact.ingles
        }
      }
    },
    data() {
      return {
        imgPath: IconeBds
      }
    }
  })
</script>

<style scoped lang="css">

  .block-split__header {
    padding-left: 86px;
    padding-top: 24px;
  }
  .block-split__header h1 {
    font-family: 'Bebas-Neue-Light';
    color: #000000;
    font-size: 64px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 77px;
  }

  .block-split__header h3 {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .block-split__header img {
    width: 20px;
    margin-right: 10px;
    object-fit: cover;
  }

  @media screen and (max-width: 769px) {
    .block-split__header h1 {
      font-family: 'Bebas-Neue-Light';
      color: #000000;
      font-size: 48px;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 58px;
    }    
  }  
</style>
